import { render, staticRenderFns } from "./JobFuture.vue?vue&type=template&id=6a8af64e&scoped=true&"
import script from "./JobFuture.vue?vue&type=script&lang=js&"
export * from "./JobFuture.vue?vue&type=script&lang=js&"
import style0 from "./JobFuture.vue?vue&type=style&index=0&id=6a8af64e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8af64e",
  null
  
)

export default component.exports